import { render, staticRenderFns } from "./UiChartLine.vue?vue&type=template&id=35cd11e2"
import script from "./UiChartLine.vue?vue&type=script&lang=js"
export * from "./UiChartLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports